<template>
  <a-card nopad>
    <div class="d-flex caption">
      <v-col>
        <elwrapper label="Single">
          <div class="room-sum">{{ roomBreakdownSingle }}</div>
        </elwrapper>
        <elwrapper label="Double">
          <div class="room-sum">{{ roomBreakdown.DOUBLE_QK }}</div>
        </elwrapper>
        <elwrapper label="Twin">
          <div class="room-sum">{{ roomBreakdown.DOUBLE_DOUBLE }}</div>
        </elwrapper>
        <elwrapper label="Triple">
          <div class="room-sum">{{ roomBreakdown.TRIPLE }}</div>
        </elwrapper>
        <elwrapper label="Quad">
          <div class="room-sum">{{ roomBreakdown.QUAD }}</div>
        </elwrapper>
      </v-col>

      <v-col>
        <elwrapper label="# of rooms">
          <div class="room-sum">{{ totalRooms }}</div>
        </elwrapper>
        <elwrapper label="# of pax">
          <div class="room-sum">{{ totalPax }}</div>
        </elwrapper>
      </v-col>
    </div>
    <div v-if="mismatchedRoomCount > 0" class="red--text font-weight-bold caption px-3 pb-2">
      ** Warning: {{ mismatchedRoomCount }}
      {{ mismatchedRoomCount === 1 ? "room has" : "rooms have" }} a type / occupant mismatch
    </div>
  </a-card>
</template>

<script>
import BOOKING_ROOMS from "@/config/BOOKING_ROOMS";
export default {
  props: {
    roomList: Array,
    specialList: Object,
  },
  computed: {
    mismatchedRoomCount() {
      if (!this.roomList) return 0;
      return this.roomList.reduce((count, room) => {
        if (room.meta && room.meta.cancelled) return count;
        const roomType = BOOKING_ROOMS.find((item) => item.value === room.type);
        if (!roomType) return count;
        if (Number(room.pax) !== Number(roomType.pax)) return count + 1;
        return count;
      }, 0);
    },
    roomBreakdown() {
      // Better way to do this? Yes.
      // Get the total of each room type
      // Split and combine to room category

      let guideAndDriverCount = 0;
      let tourLeaderCount = 0;

      if (this.specialList) {
        for (const special of this.specialList.ALL) {
          if (special.type_as === "TOUR_GUIDE" && special.is_tour_leader) {
            tourLeaderCount++;
          } else {
            guideAndDriverCount++;
          }
        }
      }

      let all = {
        SINGLE_DK: 0,
        DOUBLE_QK: 0,
        DOUBLE_DOUBLE: 0,
        TRIPLE: 0,
        QUAD: 0,

        // Add any special rooms to total
        SINGLE_GUIDE_OR_DRIVER_SUPPLIER: guideAndDriverCount,
        SINGLE_TOUR_LEADER_SUPPLIER: tourLeaderCount,
      };
      this.roomList.forEach((item) => {
        if (item.meta && item.meta.cancelled) return;
        all[item.type] += 1;
      });

      return all;
    },
    twin() {
      return parseInt(this.roomBreakdown.DOUBLE_QK) + parseInt(this.roomBreakdown.DOUBLE_DOUBLE);
    },
    totalRooms() {
      const total = this.$store.getters["BookingRoomStore/totalRooms"];

      return this.specialList && this.specialList.ALL.length ? `${total} + ${this.specialList.ALL.length}` : total;
    },
    totalPax() {
      const total = this.$store.getters["BookingRoomStore/totalPax"];
      return this.specialList && this.specialList.ALL.length ? `${total} + ${this.specialList.ALL.length}` : total;
    },
    roomBreakdownSingle() {
      const { SINGLE_DK, SINGLE_TOUR_LEADER_SUPPLIER, SINGLE_GUIDE_OR_DRIVER_SUPPLIER } = this.roomBreakdown;

      const parts = [`${SINGLE_DK}`];
      if (SINGLE_TOUR_LEADER_SUPPLIER > 0) {
        parts.push(`(${SINGLE_TOUR_LEADER_SUPPLIER})`);
      }
      parts.push(`${SINGLE_GUIDE_OR_DRIVER_SUPPLIER}`);

      return parts.join(" + ");
    },
  },
};
</script>

<style lang="scss">
.room-sum {
  height: 34px;
  display: flex;
  align-items: center;
}
</style>
